import React from 'react';
import Mapa from '../containers/mapa'
import { Link } from "react-router-dom";

const Footer = () => (
 <footer className="container-fluid clearfix p-0">
	<div id="footer" role="contentinfo">
        <div className="footer-top bg-mako padding-xs-btm-35 padding-xs-top-35">
            <div className="container">
                <div className="row footer-top-content">
                    <section className="col footer-col-1">
                        <div className="row">
                            <img src={" https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/imgs%2Flogo_footer.png?alt=media&token=3f50a864-4354-4ae1-b458-393f318e6b3f"} height="40" />
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-12">
                                <p>Elpidio González 3945<br/>C1407 Ciudad Autónoma de Buenos Aires</p>
                            </div>
                        </div>
                    </section>
                    <section className="col footer-col-2">
                        <h3 className="footer-header">Ubicacion</h3>
                        <Mapa />
                    </section>

                    <section className="col footer-col-3">
                        <h3 className="footer-header no-margin-btm">Contactanos</h3>
                        <div className="col-lg-12">
                            <p className="no-margin-btm"><span className="footer-small-header icon-phone"></span> 0800-222 8358</p>
                            <p className="no-margin"><span className="footer-small-header icon-fax"></span>  +54 11 4568-4334</p>
                            <p className="no-margin"><span className="footer-small-header icon-mail"></span> ba@velton-accesos.com.ar</p> 
                        </div>
                        <div className="mt-2">
                        <Link to="/responsabilidad" className="btn btn-secondary">
                                <i className="far fa-arrow-alt-circle-down"></i> RESPONSABILIDAD
                        </Link>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div className="footer-btm bg-outer-space">
            <div className="container">
            <b>Política de privacidad</b>
            <p className="footer-btm-text">
                Velton-Accesos se compromete a proteger la privacidad de nuestros clientes. Cualquier información que nos proporcione será tratada con extremo cuidado y confidencialidad. Nunca compartiremos o venderemos su información personal a un tercero.<br></br>
                Como parte del proceso de compra, le solicitaremos información personal, incluido su nombre, dirección, número de teléfono, dirección de correo electrónico y número de tarjeta de crédito. Tenga la seguridad de que toda la información que proporcione se utilizará estrictamente para procesar su pedido y mejorar su experiencia de cliente con Velton-Accesos<br></br>
                Nuestro sitio web utiliza SSL (Secure Sockets Layer) para garantizar transacciones seguras. Con SSL, la información enviada a través de Internet se cifra para su protección. Este proceso proporciona la manera más efectiva de garantizar un entorno de compra seguro.<br></br>
            </p>
                </div>
            <div className="container">
                <div className="footer-btm-text"><p>© 2018 Nombre de la empresa. All Rights Reserved.<br/>Tyvek®, The DuPont Oval Logo, DuPont™ are registered trademarks or trademarks of E. I. du Pont de Nemours and Company</p>
            </div>
            </div>
        </div>
    </div>
</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js